import { css, type Theme } from "@emotion/react";

export const sidebarScrollContainer = () => css`
  display: flex;
  flex-direction: column;
  max-height: calc(100% - 8rem);
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }
`;
export const sidebarContent = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  margin-top: 0.75rem;
  font-size: 0.875rem;

  li:first-of-type {
    border-top: 1px solid ${theme.system.borderBase};
  }

  li {
    border-bottom: 1px solid ${theme.system.borderBase};
  }
`;

export const contentPadding = css`
  li:last-child {
    padding: 1rem;
    border-bottom: none;
  }
`;
